import React, { useState, useEffect } from "react";
import "./versionModal.css";
import Logo from "../../../Assets/Logo.png";
import { Close } from "@material-ui/icons";
import { Button, Modal, Checkbox } from "@material-ui/core";

const VersionModal = ({ status, setStatus }) => {
  const [selectedPercentage, setSelectedPercentage] = useState(0);
  const [allowance, setAllowance] = useState(0);

  const [open, setOpen] = useState(status);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <div>
        {/*  */}
        {/* <Button onClick={handleOpen}>Version Modal</Button> */}
        <Modal
          open={status}
          onClose={() => setStatus(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="version-div">
            <div className="displayFlex">
              <div className="phnxDeposite">
                <img
                  className="version-Logo"
                  style={{ visibility: "hidden" }}
                  src={Logo}
                ></img>
              </div>
              <div className="closeModalIcon">
                <span className="cursorPointer">
                  <Close onClick={() => setStatus(false)} />
                </span>
              </div>
            </div>

            <div className="VersionMainHeading">
              <div className="version-ps-div">V1 is now updated to V1.1</div>
              <div style={{ color: "#73727d" }} className="versionParagraph">
                staking is now available via V1.1 and V1 will remain available
                for withdrawals only
              </div>
            </div>
            <a
              href="https://staking.phoenixdao.io/v2"
              style={{ textDecoration: "none" }}
            >
              <Button
                style={{
                  backgroundColor: "#413AE2",
                  borderColor: "#413AE2",
                  color: "#fff",
                  padding: "15px",
                  borderRadius: "9px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  padding: "15px",
                  textTransform: "inherit",
                  marginBottom: "30px",
                  textTransform: "inherit",
                  "&:hover": {
                    backgroundColor: "#413AE2",
                    borderColor: "#413AE2",
                    boxShadow: "none",
                  },
                  "&:active": {
                    boxShadow: "none",
                    backgroundColor: "#413AE2",
                    borderColor: "#413AE2",
                  },
                }}
                className="version-btn cursorPointer"
                onClick={() => setStatus(false)}
              >
                Go to V2 Staking dApp
              </Button>
            </a>

            <a
              href="https://test-app-ad562.web.app/"
              style={{ textDecoration: "none" }}
            >
              <Button
                style={{
                  backgroundColor: "#413AE2",
                  borderColor: "#413AE2",
                  color: "#fff",
                  padding: "15px",
                  borderRadius: "9px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  padding: "15px",
                  textTransform: "inherit",
                  marginBottom: "30px",
                  textTransform: "inherit",
                  "&:hover": {
                    backgroundColor: "#413AE2",
                    borderColor: "#413AE2",
                    boxShadow: "none",
                  },
                  "&:active": {
                    boxShadow: "none",
                    backgroundColor: "#413AE2",
                    borderColor: "#413AE2",
                  },
                }}
                className="version-btn cursorPointer"
                onClick={() => setStatus(false)}
              >
                Go to V1.1 Staking dApp
              </Button>
            </a>

            <div className="version-divider"></div>

            <div className="displayFlex versionCheckbox">
              <div className="checkboxPadding">
                <Checkbox
                  size="small"
                  checked={checked}
                  onChange={handleChange}
                  style={{
                    color: "#413AE2",
                    "&.Mui-checked": {
                      color: "#413AE2",
                    },
                  }}
                />
              </div>
              <div style={{ color: "#73727d" }} className="versionParagraph">
                I understand that V.1 smart contract upgrade due, service
                available but may be slightly disrupted.
              </div>
            </div>

            <a
              href="https://staking.phoenixdao.io/v1"
              style={{ textDecoration: "none" }}
            >
              <Button
                disabled={!checked}
                style={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #413AE2",
                  color: "#413AE2",
                  fontWeight: "bold",
                  fontSize: "16px",
                  padding: "15px",
                  textTransform: "inherit",
                  marginBottom: "30px",
                  borderRadius: "9px",
                  "&:hover": {
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #413AE2",
                    color: "#413AE2",
                    boxShadow: "none",
                  },
                  "&:disabled": {
                    boxShadow: "none",
                    backgroundColor: "#AAAAAA",
                    borderColor: "#AAAAAA",
                    color: "#FFFFFF",
                  },
                }}
                className="version-btn cursorPointer"
                onClick={() => setStatus(false)}
              >
                Continue to V1
              </Button>
            </a>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default VersionModal;
